/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Nav_Domain_PricingInputs */

const id_portal_nav_domain_pricing = /** @type {(inputs: Portal_Nav_Domain_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harga domain`)
};

const en_portal_nav_domain_pricing = /** @type {(inputs: Portal_Nav_Domain_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domain pricing`)
};

/**
* | output |
* | --- |
* | "Domain pricing" |
*
* @param {Portal_Nav_Domain_PricingInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const portal_nav_domain_pricing = /** @type {((inputs?: Portal_Nav_Domain_PricingInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Nav_Domain_PricingInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portal_nav_domain_pricing(inputs)
	return id_portal_nav_domain_pricing(inputs)
});